import React from 'react';
import PropTypes from 'prop-types';

import css from './ImageBlock.module.scss';

import SliderListBlock from 'components/SliderListBlock';
import Image from 'components/Image';

const ImageItem = (props) => {
    return <div>
        <Image {...props} image={props} />
        {props.text && (
            <div className={css.caption}>
                {props.text}
            </div>
        )}
    </div>;
};
ImageItem.propTypes = {
    image: PropTypes.string,
    text: PropTypes.string,
    altText: PropTypes.string
};
ImageItem.defaultProps = {
    images: []
};

const ImageBlock = ({ images, ...rest }) => (
    // Note: This component is designed to display images in a carousel, if you need to use a standard Image block, consider using NewImageBlock
    <SliderListBlock
        data={images}
        {...rest}
        Component={ImageItem}
        className={css.block}
        selector={'img[data-active="true"]'}
    />
);

ImageBlock.propTypes = {
    images: PropTypes.array,
    size: PropTypes.oneOf([
        'large', 'small'
    ]).isRequired
};
ImageBlock.defaultProps = {
    images: [],
    size: 'large'
};

export default ImageBlock;



// WEBPACK FOOTER //
// ./src/components/ImageBlock/ImageBlock.jsx